"use client";

import { GenerationHistoryDrawer } from "@/components/app/generation-history-drawer";
import { cn } from "@/lib/utils";
import { type GenerationWithVehicle } from "@/hooks/use-generations";

interface AppHeaderProps {
  hasPastGenerations: boolean;
  onSelectGeneration?: (generation: GenerationWithVehicle) => void;
  selectedGenerationId?: string | null;
  onCompareFreePreviews?: () => void;
  className?: string;
}

export function AppHeader({
  hasPastGenerations,
  onSelectGeneration,
  selectedGenerationId,
  onCompareFreePreviews,
  className,
}: AppHeaderProps) {
  // Don't render header if no past generations (nothing to show)
  if (!hasPastGenerations || !onSelectGeneration) {
    return null;
  }

  return (
    <header
      className={cn(
        "flex items-center justify-end py-3 px-4",
        className
      )}
    >
      <GenerationHistoryDrawer
        onSelect={onSelectGeneration}
        selectedId={selectedGenerationId}
        onCompareFreePreviews={onCompareFreePreviews}
      />
    </header>
  );
}
